import { useId, useState } from 'react';
import type { CrewSummary } from '../../data/account.ts';
import { groupInvitation, usesAppleMessages } from '../../data/group-invitation.ts';
import '../../styles/group-invitation.css';

export function GroupInvitation({ crew }: { crew: Pick<CrewSummary, 'name' | 'joinCode'> }) {
  const id = useId();
  const [note, setNote] = useState('');
  const invite = groupInvitation(window.location.origin, crew.joinCode, crew.name, usesAppleMessages(navigator.userAgent, navigator.maxTouchPoints));

  return (
    <details className="group-invitation">
      <summary>Invite friends to {crew.name}</summary>
      <p className="muted">Friends can create an account from this link, then join this group. Anyone with the link or code can join.</p>
      <div className="group-invitation__actions">
        <a href={invite.email}>Email</a>
        <a href={invite.sms}>Text message</a>
        {typeof navigator.share === 'function' && (
          <button type="button" onClick={async () => {
            setNote('');
            try {
              await navigator.share({ title: invite.title, text: `Join ${crew.name} on the Lost Lands planner.`, url: invite.url });
            } catch (error) {
              if (!(error instanceof Error && error.name === 'AbortError')) setNote('Sharing did not open. Copy the invitation link below.');
            }
          }}>Share…</button>
        )}
        <button type="button" onClick={async () => {
          try {
            await navigator.clipboard.writeText(invite.url);
            setNote('Invitation link copied.');
          } catch {
            setNote('Select and copy the invitation link below.');
          }
        }}>Copy link</button>
      </div>
      <p className="muted">Choose recipients and send in your email or messaging app.</p>
      <label className="field" htmlFor={id}>
        <span>Invitation link · code {crew.joinCode}</span>
        <input id={id} type="text" readOnly value={invite.url} onFocus={(event) => event.currentTarget.select()} />
      </label>
      {note && <p role="status">{note}</p>}
    </details>
  );
}
